<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="white",
      absolute,
      top
    )
    v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
      v-col.py-0.text-right
        v-btn(color="white", @click="save()", :disabled="loading") Save

    v-row(v-if="!loading")
      v-col.py-0
        v-card.elevation-24.pa-10.mb-5(style="overflow: hidden")
          v-form
            v-row.mb-5
              v-col.d-flex(cols="6")
                h2.display-1.font-weight-light.underline.underline--black EntityMap
            v-row(justify-end)
              v-col.pt-0
                v-row(dense, align="center")
                  v-col(cols="3")
                    v-text-field(label="Name", v-model="map.name")
                  v-col(cols="3")
                    v-text-field(label="Maps to Entity", v-model="map.entity")
                  v-col(cols="3")
                    v-select(label="From", :items="$store.state.schema.all", item-text="name", return-object, @input="setMap")
                v-row
                  v-col(cols="4")
                    v-text-field(label="Name", v-model="field.name")
                  v-col(cols="4")
                    v-text-field(label="MapsTo", v-model="field.mapsToField" @keydown.enter="map.fields.push({...field}) ; field = {mapsToField: '', name: ''}")
                  v-col(cols="4")
                    v-text-field(label="Type", v-model="field.type" @keydown.enter="map.fields.push({...field}) ; field = {mapsToField: '', name: ''}")

                v-row(v-for="(f, index) in map.fields", :key="index")
                  v-col(cols="4")
                    v-text-field(label="Name", v-model="f.name", @input="removeIfEmpty(f, index, map.fields)")
                  v-col(cols="4")
                    v-text-field(label="MapsTo", v-model="f.mapsToField", @input="removeIfEmpty(f, index, map.fields)")
                  v-col(cols="4")
                    v-text-field(label="Type", v-model="f.type", @input="removeIfEmpty(f, index, map.fields)")
</template>

<script>
import assign from 'lodash/assign'
import axios from 'axios'

export default {
  name: 'entity-add',
  data: () => ({
    loading: true,
    instance: {},
    field: {
      mapsToField: '',
      name: '',
      type: '',
    },
    errors: {},
    map: {
      name: '',
      fields: [],
      entity: '',
    }
  }),
  computed: {
    objectFields: {
      get () {
        return this.arrayFieldsToObject(this.map)
      },
      set (fields) {
        this.map.fields = this.ObjectFieldsToArray({fields})
      }
    },
    stringMap: {
      get () {
        return JSON.stringify(this.map, null, 4)
      },
      set (value) {
        this.map = JSON.parse(value)
      }
    },
    entityName () {
      return 'EntityDescriptor'
    },
    entity () {
      return this.$searchEntity(this.entityName, 'name')
    },
    uid () {
      return this.$route.params.item
    }
  },
  methods: {
    setMap (map) {
      this.map = {...map, name: map.name }
      this.map.fields = this.map.fields.map(f => ({...f, mapsToField: f.name}))
      this.map.entity = map.name
    },
    removeIfEmpty (field, index, fields) {
      !field.name && !field.mapsToField && fields.splice(index, 1)
    },
    arrayFieldsToObject (map) {
      var fields = {}
      for (var f of map.fields)
        fields[f.name] = f.mapsToField
      return fields
    },
    ObjectFieldsToarray (map) {
      var fields = []
      for (const [key, value] of Object.entries(map.fields))
        fields.push({
          name: key,
          mapsToField: value
        })
      return fields
    },
    /* TODO: docs */
    update (instance, entity) {
      this.map = assign({}, this.map, entity ? { [entity]: instance } : instance)
    },

    /* TODO: docs */
    async save () {
      // this.loading = true
      try {
        this.map = (await axios.post('entity/graph', {
          _Entity: 'EntityDescriptor',
          entityState: this.map && this.map.id ? 3 : 4,
          entity: this.map.entity,
          category: 1,
          name: this.map.name,
          mapsTo: this.map.mapsTo,
          uid: this.map.uid,
          fields: this.map.fields
        })).data
        this.$router.push({
          name: 'entities.index',
          params: { entity: 'EntityDescriptor' }
        })
      } catch (error) {
        this.errors = error.response.data.errors
      }
      // this.loading = false
    },

    /* TODO: docs */
    async load () {
      if (this.uid) {
        try {
          this.map = (await axios.get(`${this.entity.name}/${this.uid}`, {
            _Entity: this.entity.name,
            uid: this.uid
          })).data
        } catch (error) {
          console.error(error)
        }
      }
      this.loading = false
    }
  },
  async mounted () {
    await this.load()
  },
}
</script>

<!--
{
    "name": "IBM.Order.V1",
    "entity": "Order",
    "fields": {
      "FooIdScope": "BusinessScopeId"
    }
}
 -->
